import { handleActions } from 'redux-actions';
import { Map,fromJS } from 'immutable';
import actions from '../actions';
import { setAvail } from './availUtils';

//REDUCERS
const availActions = actions.avail;
export default handleActions(
  {
    [setAvail.toString()]: (avails, { payload }) => {

      const mapAvail = fromJS(payload);

      //const prevHotelAvail = avails.getIn(payload.get("availKey"), Map());

      //return avails.setIn(payload.get("availKey"), prevHotelAvail.merge(payload.get("avail")));

      mapAvail.forEach((avail, hotelId) => {
        const firstKey = avail.keySeq().first();
        avails = avails.setIn([hotelId, firstKey], avail.getIn([firstKey]));
      });
      return avails;
    },
    [availActions.getAvailParsed.toString()]: (avails, { payload }) => {
      payload.forEach((avail, hotelId) => {
        const firstKey = avail.keySeq().first();
        avails = avails.setIn([hotelId, firstKey, 'response'], avail.getIn([firstKey, 'response']));
      });
      return avails;
    },
    [availActions.resetAvail.toString()]: (avails, { payload }) => {
      return avails.set(payload, Map());
    }
  },
  Map()
);

//REDUCERS
//export default combineReducers({ hotel }, Record({ hotel: undefined }));
